import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useClipboardCopy } from "@sundae/react-hooks";
import { CheckCircledIcon, CopyIcon, Text, Tooltip } from "@sundae/ui-toolkit";
import { useCallback } from "react";
import cx from "classnames";
import { truncate } from "../../utils/truncate";
export const CopyText = ({ prefix, copyText, label, truncateLength = 12, className, textProps = {}, children, ...props }) => {
    const mergedProps = {
        variant: "muted",
        tag: "span",
        size: "xs",
        ...textProps,
    };
    const clipboard = useClipboardCopy({ copiedTimeout: 1500 });
    const handleClipboardCopy = useCallback(() => {
        clipboard.copy(copyText);
    }, [copyText, clipboard.copy]);
    return (_jsxs("div", { className: cx("flex items-center gap-2", className), ...props, children: [children ? (_jsx(_Fragment, { children: children })) : (_jsxs(Text, { tag: "p", size: "sm", children: [prefix && `${prefix}: `, _jsx(Text, { ...mergedProps, children: truncate(copyText, truncateLength) })] })), _jsx(Tooltip, { primitiveProps: {
                    trigger: { asChild: true },
                }, tooltipLabel: prefix && _jsx("div", { className: "whitespace-wrap break-all", children: label }), trigger: clipboard.copied ? (_jsx(CheckCircledIcon, { className: "text-success dark:text-success fill-current" })) : (_jsx(CopyIcon, { className: "transition-opacity hover:opacity-75", role: "button", onClick: handleClipboardCopy })) })] }));
};
export default CopyText;
//# sourceMappingURL=CopyText.js.map